module.exports = {
  1: { api: 1, human: 'Einzel-/Doppelgarage' },
  2: { api: 2, human: 'Tief-/ Sammelgarage' },
  3: { api: 3, human: 'sonstiger überdachter Stellplatz (z.B. Carport)' },
  4: { api: 4, human: 'offener Standort (z.B. Straße)' }
}
